// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  list(context,params) {
    context.commit("set_loading");
    const {pagination, search, filters, expand} = params

    var filter = [];
    Object.keys(filters).forEach((key) => {
        filter[key] = filters[key]
    });

    let sort = pagination.sortBy[0];

    if(pagination.sortDesc[0] == false){
      sort = '-'+sort;
    }
    let page = pagination.page
    let rows_per_page = pagination.itemsPerPage


    return new Promise(resolve => {
      NewApiService.get("admin/build", {
        sort, page, search, filter, expand, rows_per_page
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  get(context, buildId){
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("admin/build/"+buildId)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  
  completeBuild(context, buildId){
    return new Promise(resolve => {
      NewApiService.post("admin/build/"+buildId+"/complete-build")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  markAsBuilt(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("admin/handling/"+ params.handlingId +"/mark-as-built/" + params.id, {
        model: params.model,
        comment: params.comment
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
          reject(response)
        });
    });
  },
  markAsPending(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("admin/handling/" + params.handlingId + "/mark-as-pending/" + params.id, {
        model: params.model,
        comment: params.comment
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  markAsShipped(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("admin/build/"+params.id+"/mark-as-shipped", {
        trackingId: params.trackingId,
        comment: params.comment
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  assignToCart(context, params){
    const {buildId, cartId, items} = params
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("admin/build/"+buildId+"/assign-to-cart",{cartId, items})
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  changeStatus(context, params){
    context.commit("set_loading");
    const {status_id} = params;
    return new Promise(resolve => {
      NewApiService.put("admin/build/"+params.id,{status_id})
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  getHandlingList(context, buildId){
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("admin/build/"+buildId+"/handling-list")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  createInvoiceAndCloseBuilding(context, buildId){
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("admin/build/"+buildId+"/create-invoice-close-building")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  }
};
